import { CustomerModel } from "../models/CustomerModel";
import API, { client } from "./API";

const CustomerService = {
  async getAllCustomers() {
    const response = await API().get("Customer", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularCustomer(customer_id: number) {
    const response = await API().get("Customer");
    return response.data.filter(
      (cur_customer: CustomerModel) => cur_customer.customerId === customer_id
    )[0];
  },
  async isGreenCustomer(segment_id: number, customer_id: number) {
    const response = await API().get(
      "Customer/IsGreenCustomer/" + segment_id + "/" + customer_id,
      {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  },
  async createCustomer(data: CustomerModel, id?: number) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id ? `Customer/${id}` : "Customer",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default CustomerService;
